/*  Componente de página para o cadastro de artigo
    Este elemento é referenciado na configuração de rotas em src/routes.js 
    Este componente encapsula o componente CadastroArtigo que contém o formulário real de cadastro 
*/
import CadastroArtigo from '../../componentes/CadastroArtigo';


const PaginaArtigo = () => {
    return (
        <div className="container-fluid mt-3">
            <CadastroArtigo />
        </div>
    )
}

export default PaginaArtigo